'use strict';

angular.module('shiftTraderApp')
  .controller('NavTopCtrl', function ($scope, $location, $window, Session, ActivityIndicatorService) {
    var backPath = [];
    $scope.notAtHome = false;

    $scope.me = Session.me;

    $scope.$on('updatedSessionMe', function() {
      $scope.me = Session.me;
    });

    // loggedIn var describes whether there is a logged-in user currently using the site
    $scope.loggedIn = Session.isLoggedIn();
    $scope.$on('loginStateChanged', function(event, data) {
      $scope.loggedIn = data.state;
    });

    $scope.goBack = function() {
      setTimeout(function() {
        $window.history.back();
        $scope.$spMenu.hide();
      },100);
    };

    $scope.$on('$locationChangeSuccess', function(event, newUrl, oldUrl) {
      var testString = newUrl.split('#/');
      testString.splice(0, 1);
      testString = testString.join('#/');
      console.log(testString);

      if (_.any(['home','trades','messages','employeeSchedule','schedule', 'menu'], function(x) {
        return testString === x;
      })) {
        backPath = [];
        $scope.notAtHome = false;
      } else {
        $scope.notAtHome = true;
      }
    });

    $scope.loadingIndicatorActive = false;
    $scope.$watch(function() {
      return ActivityIndicatorService.isActivityInProgress();
    }, function(newVal) {
      $scope.loadingIndicatorActive = newVal;
    });

    $scope.$on('setTopNavTitle', function(event, titleText) {
      $scope.title = titleText;
    });
  });
